// extracted by mini-css-extract-plugin
export var active = "_2k-d";
export var blink = "_2k-e";
export var container = "_2k-5";
export var controls = "_2k-0";
export var controlsRight = "_2k-1";
export var fakeCursor = "_2k-c";
export var hidden = "_2k-b";
export var quillContainerSmall = "_2k-7";
export var quillEditor = "_2k-6";
export var quillEditorSmall = "_2k-8";
export var quillFormatButtons = "_2k-a";
export var quillToolbar = "_2k-9";
export var removePadding = "_2k-2";
export var state = "_2k-3";
export var stateTitle = "_2k-4";